import { render } from "./SetPassword.vue?vue&type=template&id=4cd12265&scoped=true"
import script from "./SetPassword.vue?vue&type=script&lang=js"
export * from "./SetPassword.vue?vue&type=script&lang=js"

import "./SetPassword.vue?vue&type=style&index=0&id=4cd12265&scoped=true&lang=css"
import "./SetPassword.vue?vue&type=style&index=1&id=4cd12265&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd12265"]])

export default __exports__